export enum Module {
  Appointment = "appointment",
  Home = "home",
}
